<div class="dropdown">
  <button class="tw-bg-grayLight tw-px-2 tw-py-1 tw-rounded-sm" (click)="toggleSort('')">
    {{sortByLabel}} <fa-icon [icon]="faSort"></fa-icon>
  </button>
  <div class="dropdown-content" [ngStyle]="{'display': isOpen ? 'block': 'none'}">
    <app-sort-content (applySortEvent)="toggleSort($event)"></app-sort-content>
  </div>
</div>